<template>
    <DCard
        padding
    >
        <DTable
            :items="pairs"
            :fields="[
                {key: 'id', label: __('tools.testing.open-stack.table.id')},
                {key: 'project', label: __('tools.testing.open-stack.table.project')},
                {key: 'contract', label: __('tools.testing.open-stack.table.contract_id')},
                {key: 'customer', label: __('tools.testing.open-stack.table.customer_id')},
                {key: 'name', label: __('tools.testing.open-stack.table.name')},
                {key: 'status', label: __('tools.testing.open-stack.table.status')},
                {key: 'flavor', label: __('tools.testing.open-stack.table.flavor')},
                {key: 'date', label: __('tools.testing.open-stack.table.date')},
                {key: 'actions', label: 'Action', sorter: false, filter: false}
            ]"
            hover
            stripedColumns
        >
            <template #id="{item}">
                <td>
                    <div v-if="item.cloudServer">
                        <span :style="item.contract ? 'color: green' : 'color: red'">
                            {{ item.cloudServer.id }}
                        </span>
                    </div>
                    <div v-if="item.cloudServer && item.contract">
                        <span :style="item.cloudServer.id === item.contract.external_id ? 'color: green' : 'color: red'">
                            {{ item.cloudServer.crmIdentifier }}
                        </span>
                    </div>
                    <div v-else-if="item.cloudServer">
                        <span style="color: grey">
                            {{ item.cloudServer.crmIdentifier }}
                        </span>
                    </div>
                    <div v-else-if="item.contract">
                        <span style="color: grey">
                            {{ item.contract.external_id }}
                        </span>
                    </div>
                </td>
            </template>
            <template #project="{item}">
                <td>
                    <span v-if="item.cloudServer?.project">
                        {{ item.cloudServer?.project.name }}
                    </span>
                    <span v-else>
                        N/A
                    </span>
                </td>
            </template>
            <template #contract="{item}">
                <td>
                    <a
                        v-if="item.contract"
                        :href="getOneCrmContractLink(item.contract)"
                        target="_blank"
                    >
                        {{ item.contract.id }}
                    </a>
                    <span v-else>
                        N/A
                    </span>
                </td>
            </template>
            <template #customer="{item}">
                <td>
                    <a
                        v-if="item.contract"
                        :href="getOneCrmCustomerLink(item.contract)"
                        target="_blank"
                    >
                        {{ item.contract.customer_id }}
                    </a>
                    <span v-else>
                        N/A
                    </span>
                </td>
            </template>
            <template #name="{item}">
                <td>
                    <span v-if="item.cloudServer">
                        {{ item.cloudServer.name }}
                    </span>
                    <span v-else>
                        {{ __('tools.testing.open-stack.table.instance_not_found') }}
                    </span>
                </td>
            </template>
            <template #status="{item}">
                <td>
                    <div v-if="item.cloudServer">
                        {{ item.cloudServer.status }}
                    </div>
                    <div v-if="item.contract">
                        {{ item.contract.status }}
                    </div>
                </td>
            </template>
            <template #flavor="{item}">
                <td>
                    <span v-if="item.cloudServer">
                        {{ item.cloudServer.cpu }} CPU<br>
                        {{ item.cloudServer.ram }} MB RAM<br>
                        {{ item.cloudServer.diskSpace }} GB
                    </span>
                    <span v-else>
                        N/A
                    </span>
                </td>
            </template>
            <template #date="{item}">
                <td>
                    <div v-if="item.cloudServer">
                        {{ (new Date(item.cloudServer.created)).toLocaleString() }}
                    </div>
                    <div v-if="item.contract">
                        {{ (new Date(item.contract.created_at)).toLocaleString() }}
                    </div>
                </td>
            </template>
            <template #actions="{item}">
                <td>
                    <div style="display: flex; grid-gap: 10px">
                        <DButtonDropdown
                            :class="'contact-list-dropdown'"
                            icon="dots-horizontal"
                        >
                            <DDropdownItem
                                v-if="item.contract"
                                icon="tray-full"
                                :href="getFulfillmentLink(item.contract)"
                                target="_blank"
                            >
                                {{ __('customers.contracts.fulfillment_requests') }}
                            </DDropdownItem>
                            <DDropdownSpacer />
                            <DDropdownItem
                                v-if="item.cloudServer"
                                icon="server-outline"
                                :href="getOpenStackHorizonLink(item.cloudServer.id)"
                                target="_blank"
                            >
                                {{ __('tools.testing.open-stack.actions.go_to_openstack') }}
                            </DDropdownItem>
                        </DButtonDropdown>
                    </div>
                </td>
            </template>
        </DTable>
    </DCard>
</template>

<script setup>

import { __ } from '~@/Composables/translation'
import { route } from '~@/Composables/route'

defineProps({
    pairs: {
        type: Array,
        default: () => { return [] }
    },
})

function getOpenStackHorizonLink (instanceId) {
    return 'https://dashboard.os2.openstack.group.one/horizon/admin/instances/' + instanceId + '/detail'
}

function getOneCrmContractLink (contract) {
    return route('customers.customers.contracts.show', {
        customer: contract.customer_id,
        contract: contract.id
    })
}

function getOneCrmCustomerLink (contract) {
    return route('customers.customers.show', {
        customer: contract.customer_id,
    })
}

function getFulfillmentLink (contract) {
    return route('tools.fulfillment.index', {
        contract: contract.id,
        reset: 0
    })
}

</script>
